import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  listCustomerCreditCards,
  // getCustomerCreditCard,
  // getCustomerCreditCardDefault,
  addCustomerCreditCard,
  addStripeCustomerCreditCard,
  addPaystackCustomerCreditCard,
  editCustomerCreditCard,
  editStripeCustomerCreditCard,
  editPaystackCustomerCreditCard,
  deleteCustomerCreditCard
} from './api';
import {
  LIST_CUSTOMER_CREDIT_CARDS_REQUEST,
  // GET_CUSTOMER_CREDIT_CARD_REQUEST,
  GET_CUSTOMER_CREDIT_CARD_SUCCESS,
  CUSTOMER_CREDIT_CARD_REQUESTING,
  LIST_CUSTOMER_CREDIT_CARDS_SUCCESS,
  RESET_CUSTOMER_CREDIT_CARD_ISFETCHING,
  ADD_CUSTOMER_CREDIT_CARD_REQUEST,
  ADD_STRIPE_CUSTOMER_CREDIT_CARD_REQUEST,
  ADD_PAYSTACK_CUSTOMER_CREDIT_CARD_REQUEST,
  EDIT_CUSTOMER_CREDIT_CARD_REQUEST,
  EDIT_STRIPE_CUSTOMER_CREDIT_CARD_REQUEST,
  EDIT_PAYSTACK_CUSTOMER_CREDIT_CARD_REQUEST,
  DELETE_CUSTOMER_CREDIT_CARD_REQUEST,
  DELETE_CUSTOMER_CREDIT_CARD_SUCCESS
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(listCustomerCreditCards, action.queryString);
    yield put({
      type: LIST_CUSTOMER_CREDIT_CARDS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* add(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      addCustomerCreditCard,
      action.customerCreditCard
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* addStripe(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      addStripeCustomerCreditCard,
      action.customerCreditCard
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* addPaystack(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(addPaystackCustomerCreditCard, action.payload);
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* edit(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      editCustomerCreditCard,
      action.customerCreditCardId,
      action.data
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* editStripe(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      editStripeCustomerCreditCard,
      action.customerCreditCardId,
      action.data
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* editPaystack(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      editPaystackCustomerCreditCard,
      action.customerCreditCardId,
      action.payload
    );
    yield put({
      type: GET_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* deleteObj(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_CREDIT_CARD_REQUESTING });
    const response = yield call(
      deleteCustomerCreditCard,
      action.customerCreditCardId
    );
    yield put({
      type: DELETE_CUSTOMER_CREDIT_CARD_SUCCESS,
      payload: { id: action.customerCreditCardId }
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_CREDIT_CARD_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* watchList() {
  yield takeLatest(LIST_CUSTOMER_CREDIT_CARDS_REQUEST, list);
  yield takeLatest(ADD_CUSTOMER_CREDIT_CARD_REQUEST, add);
  yield takeLatest(ADD_STRIPE_CUSTOMER_CREDIT_CARD_REQUEST, addStripe);
  yield takeLatest(ADD_PAYSTACK_CUSTOMER_CREDIT_CARD_REQUEST, addPaystack);
  yield takeLatest(EDIT_CUSTOMER_CREDIT_CARD_REQUEST, edit);
  yield takeLatest(EDIT_STRIPE_CUSTOMER_CREDIT_CARD_REQUEST, editStripe);
  yield takeLatest(EDIT_PAYSTACK_CUSTOMER_CREDIT_CARD_REQUEST, editPaystack);
  yield takeLatest(DELETE_CUSTOMER_CREDIT_CARD_REQUEST, deleteObj);
}

export default function* customerCreditCardSagas() {
  yield all([watchList()]);
}
